/**
 * Created by fworld on 2019/6/29.
 */
import deviceDetail from './device'
import drinkDetail from './drink'
import screenDetail from './screen'
import maintainSet from './maintainSet'
import faultDetail from './fault'

const device = {
    name: 'delivery.device',
    path: '/delivery/device',
    meta: {title: '成员管理'},
    component: () => import('@/pages/redirect'),
    redirect: {name: 'delivery.devices'},
    children: [
        {
            name: 'delivery.devices.fee',
            path: 'fee',
            meta: {title: '费用清单'},
            component: () => import('@/pages/Delivery/Device/Fee'),
        },
        {
            name: 'delivery.devices.analyze',
            path: 'analyze',
            meta: {title: '数据分析'},
            component: () => import('@/pages/Delivery/Device/Analyze'),
        },
    ].concat(deviceDetail).concat(drinkDetail).concat(screenDetail).concat(maintainSet).concat(faultDetail)
}

export default device
